// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.img_iconX {
  position: absolute;
  top: 0;
  right: 0;
  padding: 3%;
  cursor: pointer;
}

.img_iconTelaLogin {
  width: 20rem;
  height: 14.063rem;
  object-fit: contain;
}
`, "",{"version":3,"sources":["webpack://./src/modais/ModalInfoLivro.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB","sourcesContent":[".img_iconX {\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 3%;\n  cursor: pointer;\n}\n\n.img_iconTelaLogin {\n  width: 20rem;\n  height: 14.063rem;\n  object-fit: contain;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
